module.exports = __webpack_public_path__ + "static/media/gauge.be570a27.svg";